import React from 'react';
import styled from 'styled-components';
import PlayupThemeProvider from '../../../themes/PlayupThemeProvider';

export interface SectionProps {
	tabs: Array<{
		label: string;
		value?: string;
	}>;
	isSmall: boolean;
	setCategory: (label: string) => void;
	category: string;
}

const PortalSectionTab = ({ isSmall, category, setCategory, tabs }: SectionProps) => {
	return (
		<PlayupThemeProvider>
			<FilterSection isSmallScreen={isSmall}>
				{tabs.map((tab) => {
					return (
						<FilterOption
							key={tab.label}
							selected={category === (tab?.value ?? tab.label)}
							onClick={() => setCategory(tab?.value ?? tab.label)}
						>
							<FilterOptionText isSmallScreen={isSmall}>{tab.label}</FilterOptionText>
						</FilterOption>
					);
				})}
			</FilterSection>
		</PlayupThemeProvider>
	);
};

export default PortalSectionTab;

const FilterOption = styled.button<{ selected: boolean }>`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme, selected }) => (selected ? theme.colors.darkGreyRHighlight : theme.colors.darkGreyR)};

	&:hover {
		background-color: ${({ theme }) => theme.colors.darkGreyRHighlight};
	}

	&:focus {
		outline: none;
	}
`;

const FilterOptionText = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	color: theme.colors.white,
	userSelect: 'none',
	fontSize: isSmallScreen ? '14px' : '18px',
}));

const FilterSection = styled.div<{ isSmallScreen: boolean }>({
	flex: 1,
	display: 'flex',
	flexDirection: 'row',
	height: '55px',
	minHeight: '55px',
});
